import React from 'react';
import { withStyles } from '@mui/styles';
import zIndex from '@mui/material/styles/zIndex';

const styles = {
  root: {
    height: '23px',
    width: '10px',
    display: 'flex',
    alignItems: 'center',
    //backgroundColor: '#fff',
    justifyContent: 'center',
    '&:hover polyline': {
      stroke: '#00B7FF',
    },
  },
  svg: {
    position: 'absolute',
    left: '7px',
    zIndex: '120',
    height: '100%',
    width: '100%',
  },
};

const ZigzagDivider = ({ classes }) => {
  return (
    <div className={classes.root}>
      <svg
        viewBox="0 0 20 23"
        preserveAspectRatio="none"
        className={classes.svg}
      >
        {/* <polyline
          points="10,0 10,23"
          stroke="#E1DCEF"
          strokeWidth="4px"
          strokeDasharray="3,1"
          fill="none"
        /> */}
      </svg>
      {/* <svg viewBox="0 0 20 100" preserveAspectRatio="none" className={classes.svg}>
        <polyline
          points="14,0 14,100"
          //points="14,0 14,25 10,50 14,75 14,100"
          stroke="#BDC7E2"
          strokeWidth="2"
          fill="none"
        />
      </svg> */}
    </div>
  );
};

export default withStyles(styles)(ZigzagDivider);
